import Vue from "vue";
import commons from "./commons";

const information = {
	name: "information",
	fieldName: "information",
	displayName: "Information",
};

const activity = {
	name: "activity",
	fieldName: "activities",
	displayName: "Activity",
};

const standard = {
	name: "standardActivity",
	fieldName: "standardActivities",
	displayName: "Standard",
};

const state = {
	name: "state",
	fieldName: "states",
	displayName: "State",
};

const flow = {
	name: "flow",
	fieldName: "flows",
	displayName: "Flow",
};

const menu = {
	name: "menu",
	fieldName: "menus",
	displayName: "Listing",
};

const document= {
	name: "document",
	fieldName: "documents",
	displayName: "Template",
};

const action = {
	name: "action",
	fieldName: "actions",
	displayName: "Custom",
};

const logic = {
	name: "logicService",
	fieldName: "logicServices",
	displayName: "Logic",
};

/* information */
const initInformation = (item) => {
	let selected = {...item};

	if (!selected.id) {
		selected.id = commons.generateFieldName();
		selected.fieldName = commons.generateFieldName();
	}

	return selected;
};
/* set */
const setInformation = (canvas, item) => {
	if (!commons.isArray(canvas[information.fieldName])) {
		canvas[information.fieldName] = [];
	}

	const findIndex = canvas[information.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[information.fieldName], findIndex, item);
	} else {
		let findDeep = _.findDeep(canvas[information.fieldName], x => x.id == item.id, {
			childrenPath: "fields",
		});
		if (findDeep && findDeep.parent && findDeep.key) {
			Vue.set(findDeep.parent.fields, findDeep.key, item);
		} else {
			canvas[information.fieldName].push(item);
		}
	}
};
/* delete */
const deleteInformation = (canvas, item) => {
	const findIndex = canvas[information.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[information.fieldName].splice(findIndex, 1);
	} else {
		let findDeep = _.findDeep(canvas[information.fieldName], x => x.id == item.id, {
			childrenPath: 'fields'
		});
		if (findDeep && findDeep.parent && findDeep.key) {
			Vue.delete(findDeep.parent.fields, findDeep.key);
		}
	}
};
/* activity */
const initActivity = (item) => {
	let selected = {...item};

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/* set */
const setActivity = (canvas, item) => {
	if (!commons.isArray(canvas[activity.fieldName])) {
		canvas[activity.fieldName] = [];
	}

	const findIndex = canvas[activity.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[activity.fieldName], findIndex, item);
	} else {
		canvas[activity.fieldName].push(item);
	}
};
/* delete */
const deleteActivity = (canvas, item) => {
	const findIndex = canvas[activity.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[activity.fieldName].splice(findIndex, 1);
	}
};
/* standard */
/* set */
const setStandard = (canvas, item) => {
	if (!commons.isArray(canvas[standard.fieldName])) {
		canvas[standard.fieldName] = [];
	}

	const findIndex = canvas[standard.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[standard.fieldName], findIndex, item);
	} else {
		canvas[standard.fieldName].push(item);
	}
};
/* state */
const initState = (item) => {
	let selected = {...item};

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/* set */
const setState = (canvas, item) => {
	if (!commons.isArray(canvas[state.fieldName])) {
		canvas[state.fieldName] = [];
	}

	if (Boolean(item.initial)) {
		canvas[state.fieldName].forEach(x => {
			x.initial = null;
		});
	}

	const findIndex = canvas[state.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[state.fieldName], findIndex, item);
	} else {
		canvas[state.fieldName].push(item);
	}
};
/* delete */
const deleteState = (canvas, item) => {
	const findIndex = canvas[state.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[state.fieldName].splice(findIndex, 1);
	}
};
/* flow */
const initFlow = (item) => {
	let selected = {...item};

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/* set */
const setFlow = (canvas, item) => {
	if (!commons.isArray(canvas[flow.fieldName])) {
		canvas[flow.fieldName] = [];
	}

	const findIndex = canvas[flow.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[flow.fieldName], findIndex, item);
	} else {
		canvas[flow.fieldName].push(item);
	}
};
/* delete */
const deleteFlow = (canvas, item) => {
	const findIndex = canvas[flow.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[flow.fieldName].splice(findIndex, 1);
	}
};
/* menu */
const initMenu = (item) => {
	let selected = {...item};

	if (!selected.id) {
		selected.id = commons.nanoID();
	}

	return selected;
};
/* set */
const setMenu = (canvas, item) => {
	if (!commons.isArray(canvas[menu.fieldName])) {
		canvas[menu.fieldName] = [];
	}

	const findIndex = canvas[menu.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[menu.fieldName], findIndex, item);
	} else {
		canvas[menu.fieldName].push(item);
	}
};
/* delete */
const deleteMenu = (canvas, item) => {
	const findIndex = canvas[menu.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[menu.fieldName].splice(findIndex, 1);
	}
};
/* document */
const initDocument = (item) => {
	let selected = {...item};

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	selected.version = 1.0;

	return selected;
};
/* set */
const setDocument = (canvas, item) => {
	if (!commons.isArray(canvas[document.fieldName])) {
		canvas[document.fieldName] = [];
	}

	const findIndex = canvas[document.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[document.fieldName], findIndex, item);
	} else {
		canvas[document.fieldName].push(item);
	}
};
/* delete */
const deleteDocument = (canvas, item) => {
	const findIndex = canvas[document.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[document.fieldName].splice(findIndex, 1);
	}
};
/* action */
const initAction = (item) => {
	let selected = {...item};

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/* set */
const setAction = (canvas, item) => {
	if (!commons.isArray(canvas[action.fieldName])) {
		canvas[action.fieldName] = [];
	}

	const findIndex = canvas[action.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[action.fieldName], findIndex, item);
	} else {
		canvas[action.fieldName].push(item);
	}
};
/* delete */
const deleteAction = (canvas, item) => {
	const findIndex = canvas[action.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[action.fieldName].splice(findIndex, 1);
	}
};
/* logic */
const initLogic = (item) => {
	let selected = {...item};

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/* set */
const setLogic = (canvas, item) => {
	if (!commons.isArray(canvas[logic.fieldName])) {
		canvas[logic.fieldName] = [];
	}

	const findIndex = canvas[logic.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[logic.fieldName], findIndex, item);
	} else {
		canvas[logic.fieldName].push(item);
	}
};
/* delete */
const deleteLogic = (canvas, item) => {
	const findIndex = canvas[logic.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[logic.fieldName].splice(findIndex, 1);
	}
};

export default {
	information: information,
	activity: activity,
	standard: standard,
	state: state,
	flow: flow,
	menu: menu,
	document: document,
	action: action,
	logic: logic,
	initInformation: initInformation,
	initActivity: initActivity,
	initState: initState,
	initFlow: initFlow,
	initMenu: initMenu,
	initDocument: initDocument,
	initAction: initAction,
	initLogic: initLogic,
	setInformation: setInformation,
	setActivity: setActivity,
	setStandard: setStandard,
	setState: setState,
	setFlow: setFlow,
	setMenu: setMenu,
	setDocument: setDocument,
	setAction: setAction,
	setLogic: setLogic,
	deleteInformation: deleteInformation,
	deleteActivity: deleteActivity,
	deleteState: deleteState,
	deleteFlow: deleteFlow,
	deleteMenu: deleteMenu,
	deleteDocument: deleteDocument,
	deleteAction: deleteAction,
	deleteLogic: deleteLogic,
}